import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/themeFour/treasure_holder_single.png'
import _imports_1 from '@/assets/themeFour/treasure_amountbg.png'


const _hoisted_1 = { class: "reward-box" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"} }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "overlay-text" }
const _hoisted_7 = { style: {"color":"rgb(83,193,84)","font-weight":"600"} }
const _hoisted_8 = { style: {"margin-top":"0px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        style: {"width":"100%","position":"absolute","bottom":"1%"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_1,
          style: {"width":"100%","position":"absolute","bottom":"28%","left":"0.5px"}
        }, null, -1)),
        (_ctx.received != 1)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "box-img",
              src: _ctx.boxImg,
              alt: ""
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "box-img",
              src: _ctx.boxImg2,
              alt: ""
            }, null, 8, _hoisted_5)),
        _createElementVNode("div", {
          class: "rewardNum",
          style: _normalizeStyle({
          padding: '5px 0',
          color: _ctx.received == 1 ? 'gold' : 'rgba(255,255,255,.6)',
          fontWeight: _ctx.received == 1 ? '600' : '700',
        })
        }, _toDisplayString(parseFloat(_ctx.reward).toFixed(2).toString().replace(".", ",")), 5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            style: _normalizeStyle({
            color: _ctx.received != 1 ? 'rgba(255,255,255,.6)' : 'rgba(255,255,255,.6)',
            fontWeight: _ctx.received == 1 ? '700' : '700',
            marginTop: '5px',
          })
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("common.promotion")) + " ", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.peopleCount), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("common.pepole")), 1)
          ], 4)
        ])
      ])
    ])
  ]))
}